import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import de from 'vuetify/es5/locale/de';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
      locales: { de },
      current: 'de',
    },
    theme: {
      options: {
        customProperties: true
      },
      themes: {
        dark: {
          purple: "#8366FF",
          turquois: "#0EEFD2",
          rose: "#F1A7CA",
          pink: "#E72064",
          dark: '#21183D',
          anchor: '#E72064'
        }
      }
    }
});
